import { getLoginUrl } from "../utils/url-helper";
import { CliftApiError } from "./clift-api-errors";
import i18n from "i18next";

export const parseResponse = async (res: Response) => {
  if (res.ok) {
    const body = await res.text();
    if (!body) return;

    return JSON.parse(body);
  }

  // Error handling, update with login page

  if (res.status === 401) {
    window.location.replace(getLoginUrl(i18n.language, false));
    return;
  }

  const body = await res.json().catch(() => {
    throw new CliftApiError(res.status);
  });

  throw new CliftApiError(res.status, undefined, body.reason);
};
